<template>
  <div>
    <Breadcrumb></Breadcrumb>
    <div class="common-limit line-height-40">
      <div class="form-body">
        <el-form
          ref="form"
          :model="queryParams"
          label-width="80px"
          size="small"
        >
          <el-row :gutter="24">
            <el-col :span="8">
              <el-form-item label="商家账号：" prop="pOperNo">
                <el-select
                  clearable
                  size="small"
                  v-model="queryParams.pOperNo"
                  filterable
                  remote
                  :remote-method="getUserList"
                >
                  <template v-for="(value, key) in userList">
                    <el-option
                      :key="value.userName"
                      :label="
                        `${value.userName}${
                          value.nickName ? '(' + value.nickName + ')  ' : ''
                        }`
                      "
                      :value="value.userName"
                    ></el-option>
                  </template>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="操作人员：" prop="operNo">
                <el-input v-model="queryParams.operNo" clearable />
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="收支类型：" prop="fundType">
                <el-select
                  style="width: 100%"
                  clearable
                  v-model="queryParams.fundType"
                >
                  <template v-for="(value, key) in dictData['fund_type']">
                    <el-option
                      :key="value.value"
                      :label="value.label"
                      :value="value.value"
                    ></el-option>
                  </template>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="24">
            <el-col :span="8">
              <el-form-item label="产生时间：" prop="time">
                <el-date-picker
                  style="width: 100%"
                  v-model="queryParams.time"
                  type="daterange"
                  format="yyyy-MM-dd"
                  value-format="yyyy-MM-dd"
                  :picker-options="pickerOptions"
                  start-placeholder="开始时间"
                  end-placeholder="结束时间"
                >
                </el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="16" class="btn-bar-right">
              <el-button type="primary" size="small" @click="loadData"
                >搜索</el-button
              >
              <el-button size="small" @click="resetForm">重置</el-button>
            </el-col>
          </el-row>
        </el-form>
      </div>
    </div>
    <div class="form-body">
      <span style="float: left">
        <el-button size="small" type="primary" @click="handleExport"
          >导出
        </el-button>
      </span>
      <pagination
        v-show="total > 0"
        :total="total"
        :page.sync="queryParams.pageNum"
        :limit.sync="queryParams.pageSize"
        @pagination="loadData"
        :layout="'slot, total, sizes, prev, pager, next, jumper'"
      >
      </pagination>
      <el-table
        border
        :data="tableData"
        highlight-current-row
        @current-change="handleCurrentChange"
      >
        <el-table-column
          width="200"
          label="流水编号"
          prop="fundId"
        ></el-table-column>
        <el-table-column label="商家账号" prop="pOperNo"></el-table-column>
        <el-table-column label="操作人员" prop="operNo"> </el-table-column>
        <el-table-column width="169" label="产生时间" prop="createTime">
        </el-table-column>
        <el-table-column label="收支类型" prop="fundType">
          <template slot-scope="scope">
            <span>{{ dictMap["fund_type"][scope.row.fundType] }}</span>
          </template>
        </el-table-column>
        <el-table-column label="金额" prop="amount">
          <template slot-scope="scope">
            <span style="color: red" v-if="scope.row.fundType == '01'">
              + {{ scope.row.amount }}</span
            >
            <span style="color: green" v-if="scope.row.fundType == '02'">
              - {{ scope.row.amount }}</span
            >
          </template>
        </el-table-column>
        <el-table-column label="余额" prop="balance"></el-table-column>
        <el-table-column
          show-overflow-tooltip
          label="说明"
          prop="fundDesc"
        ></el-table-column>

        <el-table-column
          v-if="user.userType == '00' && showButton"
          width="60"
          fixed="right"
          label="操作"
        >
          <template slot-scope="scope">
            <el-button type="text" size="mini" @click="handleEdit(scope.row)"
              >修改</el-button
            ></template
          >
        </el-table-column>
      </el-table>
      <pagination
        class="bottom-sticky"
        v-show="total > 0"
        :total="total"
        :page.sync="queryParams.pageNum"
        :limit.sync="queryParams.pageSize"
        @pagination="loadData"
      />
    </div>
    <el-dialog
      :close-on-click-modal="false"
      title="资金修改"
      :visible.sync="dialogVisible"
    >
      <div>
        <el-form
          ref="form"
          :model="form"
          :rules="rules"
          size="small"
          label-width="160px"
        >
          <el-form-item label="商家账号：">
            {{ form.pOperNo }}
          </el-form-item>
          <el-form-item label="收支类型：" prop="fundType">
            <el-radio-group v-model="form.fundType">
              <template>
                <el-radio label="01" key="1">收入</el-radio>
                <el-radio label="02" key="0">支出</el-radio>
              </template>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="变更资金：" prop="amount">
            <el-input v-model="form.amount" placeholder=""></el-input>
          </el-form-item>
          <el-form-item label="变更说明：" prop="fundDesc">
            <el-input v-model="form.fundDesc" placeholder=""></el-input>
          </el-form-item>
        </el-form>
      </div>
      <div slot="footer">
        <el-button size="small" @click="dialogVisible = false">取 消</el-button>
        <el-button size="small" type="primary" @click="handleSave"
          >确 定</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { mapGetters } from "vuex"
import Breadcrumb from "@/components/common/Breadcrumb"
import { listFund, exportFundList, editFund } from "@/api/business/fundManage"
import { downLoadExcel } from "@/utils/zipdownload"
import qs from "qs"
import { listUser } from "@/api/business/merchantManage"

export default {
  components: { Breadcrumb },
  data() {
    return {
      queryParams: {
        pOperNo: undefined,
        operNo: undefined,
        fundType: undefined,
        beginTime: undefined,
        endTime: undefined,
        time: [],
        rechargeMode: undefined,
        pageSize: 30,
        pageNum: 1,
      },
      form: {
        fundType: "",
        fundId: "",
        amount: "",
        fundDesc: "",
      },
      total: 0,
      loading: false,
      tableData: [],
      dialogVisible: false,
      rules: {
        fundType: [
          { required: true, message: "请输入收支类型", trigger: "change" },
        ],
        amount: [
          { required: true, message: "请输入变更资金", trigger: "blur" },
        ],
        fundDesc: [
          { required: true, message: "请输入变更说明", trigger: "blur" },
        ],
      },
      userList: [],
      showButton: true,
    }
  },
  computed: {
    ...mapGetters(["dictData", "dictMap", "nginx", "user"]),
    showButton() {},
    routeName() {
      return this.$route.path
    },
    role() {
      return this.$store.state.user.roles[0]
    },
  },
  watch: {
    routeName: {
      handler() {
        let url = window.location.href
        if (url.indexOf("fundsDetailView") > -1) {
          this.showButton = false
        } else {
          this.showButton = true
        }
        if (this.role == "分站管理员") {
          this.showButton = false
        }
      },
      immediate: true,
    },
  },
  mounted() {
    this.getCache("1")
    this.loadData()
    this.getUserList()
  },
  methods: {
    async getUserList(query) {
      let pageSize = 10
      if (!query) {
        query = ""
      } else {
        pageSize = 1000
      }
      let result = await listUser({
        pageNum: 1,
        pageSize: pageSize,
        userType: "01",
        userName: query,
      })
      this.userList = result.rows
    },
    /* 获取列表数据 */
    loadData() {
      this.setCache("1")
      this.startLoading()
      if (this.queryParams.time) {
        this.queryParams.beginTime = this.queryParams.time[0]
        this.queryParams.endTime = this.queryParams.time[1]
      } else {
        this.queryParams.beginTime = undefined
        this.queryParams.endTime = undefined
      }
      let params = Object.assign({}, this.queryParams)
      delete params["time"]
      listFund(params)
        .then((res) => {
          this.total = res.total
          this.tableData = res.rows
          this.endLoading()
        })
        .catch((err) => {
          console.error(err)
          this.endLoading()
        })
    },
    resetForm() {
      this.$refs["form"].resetFields()
    },
    // 导出
    handleExport() {
      if (this.queryParams.time) {
        this.queryParams.beginTime = this.queryParams.time[0]
        this.queryParams.endTime = this.queryParams.time[1]
      } else {
        this.queryParams.beginTime = undefined
        this.queryParams.endTime = undefined
      }
      let params = Object.assign({}, this.queryParams)
      delete params["time"]
      delete params["pageSize"]
      delete params["pageNum"]
      downLoadExcel(
        `/money/fund/export?${qs.stringify(this.queryParams)}&fileName=` +
          Math.random(),
        Math.random()
      )
    },
    handleEdit(row) {
      this.dialogVisible = true
      this.$nextTick(() => {
        this.$refs["form"].resetFields()
        this.form = Object.assign({}, row)
        this.form.amount = ""
        this.form.fundDesc = ""
        this.dialogTitle = "修改"
      })
    },
    handleSave() {
      let _self = this
      this.$refs["form"].validate((valid) => {
        if (valid) {
          let form = this._.clone(_self.form)
          editFund(
            this._.pick(form, "fundId", "fundType", "amount", "fundDesc")
          ).then((response) => {
            if (response.code == "200") {
              _self.msgSuccess("修改成功！")
              _self.dialogVisible = false
              _self.loadData()
            } else {
              _self.msgError("修改失败！")
            }
          })
        } else {
          console.log("error submit!!")
          return false
        }
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.btn-bar-right {
  text-align: right;
}
</style>
